/**
 * @Author: shenyi
 * @Date:   2023-08-11 14:50:27
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-11-15 14:19:40
 */
import App from "../models/app";
import CommonTree from "../models/commonTree";
import FunctionItem from "../models/functionItem";
import KeyValue from "../models/keyValue";
import MenuItem from "../models/menuItem";
import Tenant from "../models/tenant";
import User from "../models/user";
import {
  answerNotice,
  deleteMessage,
  deleteTodo,
  doLogout,
  finishTodo,
  getAppInfoApi,
  getAppMenuApi,
  getBaseDataApi,
  getBuildingsSelector,
  getDepartments,
  getEnum,
  getIndexNewUrl,
  getLoginUserInfo,
  getMatrixData,
  getNoticeDetail,
  getStudentList,
  getTopMsgNumber,
  getTopUnReadMessage,
  getTopUnReadNotice,
  getTopUnReadTodo,
  markAllReadMessage,
  markAllReadTodo,
  markNoticeRead,
  markReadMessage,
  markReadTodo,
  querySearchTip,
  saveLog,
} from "./app.api";
import MessageDetails from "./notice/model/messageDetails";
import NoticeDetails from "./notice/model/noticeDetails";
import NoticeItem from "./notice/model/noticeItem";
import TodoDetails from "./notice/model/todoDetails";
import SearchTipItem from "./search/model/searchTipItem";
import { setCache } from "./singleton";

export default class AppService {
  deserialization = ({ subFunctionItems, ...other }: any) => {
    subFunctionItems = subFunctionItems ? subFunctionItems : [];
    let subFunctionItemList: FunctionItem[] = subFunctionItems.length
      ? subFunctionItems.map(
          (functionItem: any) => new FunctionItem(functionItem),
        )
      : [];
    return new FunctionItem({
      ...other,
      subFunctionItems: subFunctionItemList,
    });
  };
  getAppInfo = async ({
    appName = "",
    leftMenuApi = "",
    topBarUrl = "",
    enumUrl = "",
    showHeader,
  }): Promise<App> => {
    let { data: appInfo } = await getAppInfoApi({ appName, navUrl: topBarUrl });
    let { data: d } = await getAppMenuApi({ appName, leftMenuApi });
    let functionItems = [];
    let entryRegedit = [];
    if (d.length) {
      functionItems = d;
    } else {
      functionItems = d.leftMenus;
      entryRegedit = d.entryRegedit;
    }
    let { data } = await getLoginUserInfo();
    setCache(data);
    let { data: enumData } = enumUrl && (await getEnum(enumUrl));
    let { menuItems, tenant, hasSearchBar } = appInfo ?? {};
    let menuItemList =
      menuItems &&
      menuItems.length &&
      menuItems.map((menuItem: any) => new MenuItem(menuItem));
    let functionItemList =
      functionItems &&
      functionItems.length &&
      functionItems.map((functionItem: any) =>
        this.deserialization(functionItem),
      );
    tenant = new Tenant(tenant);
    let user = new User(data);

    return new App({
      menuItems: menuItemList,
      tenant,
      user,
      functionItems: functionItemList,
      enumData,
      entryRegedit,
      hasSearchBar,
    });
  };
  getBaseData = async (): Promise<CommonTree[]> => {
    let { data } = await getBaseDataApi();
    return data;
  };
  // 退出登录
  doLogout = async (token): Promise<any> => {
    let { data } = await doLogout(token);
    return data;
  };
  private getOrganizationList = (data, alist?) => {
    let list = alist || [];
    for (let item of data) {
      list.push(item);
      if (item.subItems && item.subItems.length) {
        list = this.getOrganizationList(item.subItems, list);
      }
    }
    return list;
  };

  async getStudentListSevice(): Promise<any> {
    let { data } = await getStudentList();
    return data;
  }

  // 获取部门列表
  getDepartmentList = async (categorys): Promise<CommonTree[]> => {
    let { data } = await getDepartments(categorys);
    let departmentList = data.map((department) => new CommonTree(department));
    return departmentList;
  };

  // 楼宇级联下拉
  async getBuildingsSelector(): Promise<CommonTree[]> {
    let { data } = await getBuildingsSelector();
    let buildingSelect = data.map(
      (buildingSelectItem) => new CommonTree(buildingSelectItem),
    );
    return buildingSelect;
  }

  // head
  // 功能矩阵matrix
  async getMatrixData(): Promise<any> {
    let { data } = await getMatrixData();
    return data;
  }
  async getIndexNewUrl(): Promise<any> {
    let { data } = await getIndexNewUrl();
    return data;
  }
  async saveLog(props: any): Promise<any> {
    let { data } = await saveLog(props);
    return data;
  }

  // 获得未读消息总数
  getTopMsgNumber = async (): Promise<KeyValue[]> => {
    let { data } = await getTopMsgNumber();
    let msgList = data.map((item) => new KeyValue(item));
    return msgList;
  };
  // 获取未读通知
  getTopUnReadNotice = async (): Promise<NoticeItem[]> => {
    let { data } = await getTopUnReadNotice();
    let list = data.map((item) => new NoticeItem(item));
    return list;
  };
  // 获取未读消息
  getTopUnReadMessage = async (): Promise<MessageDetails[]> => {
    let { data } = await getTopUnReadMessage();
    let list = data.map((item) => new MessageDetails(item));
    return list;
  };
  // 获取未读todo
  getTopUnReadTodo = async (): Promise<TodoDetails[]> => {
    let { data } = await getTopUnReadTodo();
    let list = data.map((item) => new TodoDetails(item));
    return list;
  };

  // 标记通知已读
  async markNoticeRead(noticeId: string): Promise<any> {
    let { data } = await markNoticeRead(noticeId);
    return data;
  }

  // 获取通知详情
  getNoticeDetail = async (noticeId): Promise<NoticeDetails> => {
    let { data } = await getNoticeDetail(noticeId);
    return data;
  };

  // 标记Todo已读
  async markReadTodo(todoIds: string[]): Promise<any> {
    let { data } = await markReadTodo(todoIds);
    return data;
  }

  // 标记全部todo已读
  async markAllReadTodo(): Promise<any> {
    let { data } = await markAllReadTodo();
    return data;
  }

  // 删除todo
  async deleteTodo(todoIds: string[]): Promise<any> {
    let { data } = await deleteTodo(todoIds);
    return data;
  }

  // 标记为完成
  async finishTodo(todoId: string): Promise<any> {
    let { data } = await finishTodo(todoId);
    return data;
  }

  // 标记消息已读
  async markReadMessage(messageIds: string[]): Promise<any> {
    let { data } = await markReadMessage(messageIds);
    return data;
  }

  // 标记全部消息已读
  async markAllReadMessage(): Promise<any> {
    let { data } = await markAllReadMessage();
    return data;
  }

  // 回复通知
  async answerNotice(noticeId: string, answerContent: string): Promise<any> {
    let { data } = await answerNotice(noticeId, answerContent);
    return data;
  }

  // 删除消息
  async deleteMessage(messageIds: string[]): Promise<any> {
    let { data } = await deleteMessage(messageIds);
    return data;
  }

  // 数据查询提示词
  querySearchTip = async (searchText = ""): Promise<SearchTipItem[]> => {
    let { data } = await querySearchTip(searchText);
    let list =
      data &&
      data.length &&
      data.map((item) => {
        return new SearchTipItem(item);
      });
    return list;
  };
}
